import {
  type Brand as BrandType,
  BrandEnum as Brand,
  ConsentStatus,
  type DeviceType as DeviceTypeType,
  DeviceTypeEnum as DeviceType,
  type Vertical as VerticalType
} from '@schibsted-nmp/advertising-shared';

import type { Settings } from './Settings';

const Config: Config = {
  [Brand.DBA]: {
    accountId: 'schibsteddk',

    [DeviceType.DESKTOP]: {
      tagName: '6746e535ae5f9061736e078f',
      [ConsentStatus.Accepted]: { configId: '675ca048d76e720181faa8a4' },
      [ConsentStatus.Rejected]: { configId: '675ca0cb77987adc10faa8a6' }
    },

    [DeviceType.MOBILE]: {
      tagName: '6746e535ae5f9061736e081b',
      [ConsentStatus.Accepted]: { configId: '677e9c590dbe305a5b5d1be5' },
      [ConsentStatus.Rejected]: { configId: '677e9c6602dcc4ef205d1be6' }
    }
  },

  [Brand.FINN]: {
    accountId: 'schibstedno',
    tagName: '674841ca854373f8fc57d8d9',
    [DeviceType.DESKTOP]: { configId: '674841d45b817321ce57d8da' },
    [DeviceType.MOBILE]: { configId: '67616e2ec4a67ddfe0845fa8' }
  },

  [Brand.TORI]: {
    accountId: 'tori',

    [DeviceType.DESKTOP]: {
      tagName: '66cecb0e1a3b9040b52acc5f',
      configId: '66d5ac2aed0ef9bb84ce3fe9'
    },

    [DeviceType.MOBILE]: {
      tagName: '66cecb0e1a3b9040b52acd7c',
      configId: '66dea8dd13855042b642272c'
    }
  }
};

type Config = Readonly<Partial<Record<BrandType, Config.BrandSpecific>>>;

namespace Config {
  export type BrandSpecific = VerticalSpecific &
    Readonly<Partial<Record<VerticalType, VerticalSpecific>>>;

  export type VerticalSpecific = ConsentSpecific &
    Readonly<Partial<Record<DeviceTypeType, ConsentSpecific>>>;

  export type ConsentSpecific = Settings &
    Readonly<Partial<Record<ConsentStatus, Settings>>>;
}

export { Config };
